import { AfterViewInit, Directive, ElementRef, OnInit } from '@angular/core';

/**
 * Automatically focus on this element after the view is initialized.
 */
@Directive({
  selector: '[zAutoFocus]',
})
export class AutoFocusDirective implements OnInit, AfterViewInit {
  constructor(private elementRef: ElementRef<HTMLInputElement>) {}

  ngOnInit() {
    if (!this.elementRef?.nativeElement?.focus) {
      console.error('This element does not support focus');
      return;
    }
  }

  ngAfterViewInit() {
    const input = this.elementRef.nativeElement;

    setTimeout(() => {
      input.focus();
      input.select();
    }, 0);
  }
}
